(function (angular) {
	'use strict';

	angular.module('goalVerificationModule', [
		'coreModule'
	]);
})(window.angular);